export default {
    byId: {},
    allIds: [],
};
